import { useEffect, useState } from "react";
import styles from "./index.module.css";
import { searchWhiteIcon } from "../../../../assets";

const SearchBar = ({
  searchTerm,
  activateSearch,
  handleSearchTerm,
  searchBarRef = null,
}) => {
  const [searchBar, setSearchBar] = useState(searchTerm || "");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setSearchBar(searchTerm || "");
  }, [searchTerm]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handler = setTimeout(() => {
      if (handleSearchTerm) {
        handleSearchTerm({ target: { value: searchBar } });
      }
    }, 1500);
    return () => clearTimeout(handler);
  }, [searchBar]);

  return (
    <form
      className={styles.searchbar}
      onSubmit={(e) => {
        e.preventDefault();

        if (searchBar.trim()) {
          activateSearch();
        }
      }}
    >
      <input
        ref={searchBarRef}
        id="mainSearchInput"
        placeholder="Search a product..."
        value={searchBar}
        onChange={(e) => setSearchBar(e.target.value)}
      />

      <button
        type="submit"
        className={`${styles.searchButton} ${styles.ovalButton}`}
      >
        {searchWhiteIcon}
        Search
      </button>
    </form>
  );
};

export default SearchBar;
